import apiMixin from "../../../mixins/apiMixin";

const Payment = {
    namespaced: true,
    state: {
        khonsu_singleSession_sessionid:null,
        khonsu_light_sessionid:null,
        khonsu_unlimited_sessionid:null,

        khonsu_userpayments:[]
    },
    mutations: {

        setkhonsu_singleSession_sessionid: function (state, payload) {
            state.khonsu_singleSession_sessionid = payload;
        },
        setkhonsu_light_sessionid: function (state, payload) {
            state.khonsu_light_sessionid = payload;
        },
        setkhonsu_unlimited_sessionid: function (state, payload) {
            state.khonsu_unlimited_sessionid = payload;
        },
        setUserPayments:function(state,payload){
            state.khonsu_userpayments =payload;
        }
    },
    actions: {
        getallpayments:function(state,payload){
            try {
                return apiMixin.methods.UserPayments(payload).then(
                    response => {
                        if(!response){return false;}
                        if(response.status === 200){

                            state.commit('setUserPayments', response.data.result);
                            return true;
                        }
                    }
                )
            } catch (e) {
                console.log(e);
            }
        },
        getkhonsu_singleSession_sessionid:function (state,payload) {
            try {
                return apiMixin.methods.ProductSessionId(payload).then(
                    response => {
                        if(!response){return false;}
                        if(response.status === 200){

                            state.commit('setkhonsu_singleSession_sessionid', response.data.result);
                            return true;
                        }
                    }
                )
            } catch (e) {
                console.log(e);
            }
        },

        getkhonsu_light_sessionid:function (state,payload) {
            try {
                return apiMixin.methods.ProductSessionId(payload).then(
                    response => {
                        if(!response){return false;}
                        if(response.status === 200){
                            state.commit('setkhonsu_light_sessionid', response.data.result);
                            return true;
                        }
                    }
                )
            } catch (e) {
                console.log(e);
            }
        },

        getkhonsu_unlimited_sessionid:function (state,payload) {
            try {
                return apiMixin.methods.ProductSessionId(payload).then(
                    response => {
                        if(!response){return false;}
                        if(response.status === 200){
                            state.commit('setkhonsu_unlimited_sessionid', response.data.result);
                            return true;
                        }
                    }
                )
            } catch (e) {
                console.log(e);
            }
        }














    },
    getters: {},
}
export default Payment
